import { createFileRoute } from '@tanstack/react-router';
import { MemberPortalManageHomePage } from '@/pages/member-portal/MemberPortalManageHomePage';
import { requireMemberPortalAuthor } from '@/lib/route-guards/member-portal-guard';

export const Route = createFileRoute('/_authenticated/_app/member-portal/overview')({
	beforeLoad: ({ context }) => requireMemberPortalAuthor(context, '/member-portal'),
	component: MemberPortalManageHomePage,
});
